import React, { useMemo } from 'react'

import { Icon, MailFilled } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, bool, func, string,
} from 'prop-types'

import { iconSize } from 'Pods/LazyLoaded/AuthModal/constants'

import ErrorMessage from './Components/ErrorMessage/ErrorMessage'
import Inputs from './Components/Inputs/Inputs'
import Resend from './Components/Resend/Resend'

function CodeStep({
  email, digits, hasError, onDigitsChange, onResend, onChangeEmail,
}) {
  const maskedEmail = useMemo(() => email.trim(), [email])

  return (
    <div className="auth-modal__code">
      <span className="auth-modal__code-icon">
        <Icon svgComponent={MailFilled} size={iconSize} notSpaced />
      </span>
      <div className="auth-modal__header-group auth-modal__header-group--center">
        <p className="auth-modal__title cgt-heading-300">Check your inbox</p>
        <p className="auth-modal__subtitle cgt-body-md">
          We sent a 6-digit code to
          {' '}
          {maskedEmail ? (
            <span className="auth-modal__email cgt-body-md-semibold">{maskedEmail}</span>
          ) : (
            'your email'
          )}
        </p>
      </div>
      <Inputs digits={digits} hasError={hasError} onDigitsChange={onDigitsChange} />
      <ErrorMessage hasError={hasError} />
      <Resend onResend={onResend} onChangeEmail={onChangeEmail} />
    </div>
  )
}

CodeStep.propTypes = {
  email: string.isRequired,
  digits: arrayOf(string).isRequired,
  hasError: bool.isRequired,
  onDigitsChange: func.isRequired,
  onResend: func.isRequired,
  onChangeEmail: func.isRequired,
}

export default CodeStep
